import RHDialog from "@RHCommerceDev/component-rh-dialog";
import {
  emailAtom,
  isCreateAccount,
  useAuthenticationDialogCurrentScreenAtom,
  useIsAuthenticationDialogAtom
} from "@RHCommerceDev/hooks/atoms";
import memoize from "@RHCommerceDev/utils/memoize";
import { useAtom, useSetAtom } from "jotai";
import * as React from "react";
import CheckYourInbox from "./check-your-inbox";
import ForgotPassword from "./forgot-password";
import MobileAuthentication from "./mobile-authentication";
import PasswordIndicator from "./PasswordIndicator";
import ResetPasswordByEmail from "./reset-password-by-email";
import SignInWithaSecureLink from "./sign-in-with-a-secure-link";
import SignInWithEmailAndPassword from "./signin-with-email-and-password";
import SignUpWithEmailAndPassword from "./signup-with-email-and-password";
import SmsCodeHandler from "./sms-code-handler";
import UpdatedPasswordWelcomePage from "./update-password-welcome-page";
import Welcome from "./welcome";

const Components = {
  SignInWithEmailAndPassword,
  SignUpWithEmailAndPassword,
  ResetPasswordByEmail,
  ForgotPassword,
  UpdatedPasswordWelcomePage,
  Welcome,
  SignInWithaSecureLink,
  CheckYourInbox,
  MobileAuthentication,
  SmsCodeHandler,
  PasswordIndicator
};

const Authentication = () => {
  const [isOpen, setIsOpen] = useIsAuthenticationDialogAtom();

  const [
    authenticationDialogCurrentScreen,
    setAuthenticationDialogCurrentScreen
  ] = useAuthenticationDialogCurrentScreenAtom();

  const Component = Components?.[authenticationDialogCurrentScreen] ?? null;
  const [isAccountCreateClicked, setIsAccountCreateClicked] =
    useAtom(isCreateAccount);
  const setEmailField = useSetAtom(emailAtom);
  const currentScreen = authenticationDialogCurrentScreen;

  return (
    <RHDialog
      open={isOpen}
      PaperProps={{
        className: `${
          currentScreen == "SignUpWithEmailAndPassword" ||
          isAccountCreateClicked
            ? "w-w-734 customMd:w-w-458"
            : "w-w-407"
        } customXs:w-w-343 h-auto shadow-drawer-shadow`
      }}
      BackdropProps={{
        style: {
          backgroundColor: "#D4D2CF",
          opacity: 0.4
        }
      }}
      showHeader={true}
      onClose={() => {
        setIsOpen(false);
        setIsAccountCreateClicked(false);
        setAuthenticationDialogCurrentScreen("SignInWithEmailAndPassword");
        setEmailField("");
      }}
      dialogTitleStyles={{
        paddingTop: 40,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        backgroundColor: "#FFF"
      }}
      DialogContentProps={{
        className:
          "flex items-center justify-center px-12 pt-0 pb-10 customXs:px-4 customXs:pb-10 pt-0 bg-[#FFF]"
      }}
    >
      <Component />
    </RHDialog>
  );
};

export default memoize(Authentication);
